import { AppFlow } from '@lib/types';

export interface UtagParam {
  channel: string;
  subchannel1: string;
  subchannel2: string;
  custid?: string;
  flow?: string;
  page?: string;
  club?: string;
  mem_autopaycampaign?: string;
  mem_level?: string;
  bill_status?: string;
  mem_autopay?: string;
  campaigncodemr?: string;
  error?: string;
}

export class UtagHelper {
  static CommonTaggingValues = (appFlow = AppFlow.PAYMENT) => {
    return {
      channel: 'my account',
      subchannel1: 'membership',
      subchannel2: `easy ${appFlow === AppFlow.AUTOPAY ? 'auto ' : ''}pay`,
    };
  };

  static Pages = (appFlow = AppFlow.PAYMENT) => {
    const isAutoPayFlow = appFlow === AppFlow.AUTOPAY;
    const appName = isAutoPayFlow ? 'easy auto pay' : 'easy pay';
    const error = isAutoPayFlow
      ? `my account:membership:${appName}:error-system`
      : `my account:membership:${appName}:system error`;

    const paymentError = isAutoPayFlow
      ? `my account:membership:${appName}:error-payment`
      : `my account:membership:${appName}:payment error`;

    const autoPay = isAutoPayFlow
      ? `my account:membership:${appName}:enrollment`
      : `my account:membership:${appName}:autopay`;
    return {
      verifyEligibility: `my account:membership:${appName}:validate your membership`,
      reviewPage: `my account:membership:${appName}:review payment`,
      emailOnFile: `my account:membership:${appName}:email on file`,
      emailNotOnFile: `my account:membership:${appName}:no email on file`,
      confirmation: `my account:membership:${appName}:confirmation`,
      expiredConfirmation: `my account:membership:${appName}:confirmation-reload`,
      autoPay,
      error,
      paymentError,
    };
  };

  static Errors = {
    systemError: 'system error',
    paymentError: 'payment error',
    autoPayFlowPaymentError: 'payment failed',
  };

  static loadUtagJs() {
    if ((window as any).utagLoadAttempt) return;
    (window as any).utagLoadAttempt = true;
    const utagJsScript = document.createElement('script');
    utagJsScript.src = '//tms.ace.aaa.com/ace/prod/utag.js';
    utagJsScript.type = 'text/javascript';
    utagJsScript.async = true;
    document.body.appendChild(utagJsScript);
  }

  static tag(tags: UtagParam) {
    (window as any).aceMediaTagValues = { ...tags };
    this.dispatchTntSpaEvent((window as any).aceMediaTagValues);
    if (typeof (window as any).utag === 'undefined') {
      this.loadUtagJs();
    } else {
      (window as any).utag.view((window as any).aceMediaTagValues);
    }
  }

  static dispatchTntSpaEvent(tags: UtagParam) {
    document.dispatchEvent(
      new CustomEvent('tnt_spa', {
        detail: tags,
      })
    );
  }
}
